import type {
  EvaluationAnswer,
  EvaluationAnswerValue,
  EvaluationQuestion
} from '../types/evaluation'

export type AnswerMap = Record<number, EvaluationAnswerValue>

/** Respostas já gravadas, no formato que o formulário consome. */
export const answersFromRecords = (answers: EvaluationAnswer[] = []): AnswerMap =>
  answers.reduce<AnswerMap>((acc, answer) => {
    acc[answer.evaluation_question_id] = answer.value
    return acc
  }, {})

export const isBlankAnswer = (value: EvaluationAnswerValue | undefined) => {
  if (value === undefined || value === null) return true
  if (typeof value === 'string') return value.trim() === ''
  if (Array.isArray(value)) return value.length === 0

  return Object.keys(value).length === 0
}

/**
 * Quais obrigatórias ainda faltam. O backend é a autoridade — ele repete essa
 * conta e é ele que recusa o envio. Aqui é só para o aluno não descobrir a
 * pendência depois de rolar até o fim e apertar enviar.
 */
export const pendingRequiredQuestions = (
  questions: EvaluationQuestion[],
  answers: AnswerMap
): EvaluationQuestion[] =>
  questions.filter(
    question =>
      question.kind !== 'heading' &&
      question.required &&
      isBlankAnswer(answers[question.id])
  )

/** Um ranking só conta como respondido quando TODAS as suas linhas têm nota. */
export const isRankingComplete = (
  question: EvaluationQuestion,
  value: EvaluationAnswerValue | undefined
) => {
  if (question.kind !== 'ranking') return true
  if (!value || typeof value !== 'object' || Array.isArray(value)) return false

  return (question.options ?? []).every(option => value[option.uid] !== undefined)
}
